const CONTACT_INFO = {
  address: "Athos Pampa, Valle de Calamuchita",
  email: "cabanasdelcampocba@gmail.com",
  phone: "+54 9 3513024564",
  instagram: "@cabanasdelcampocba",
  facebook: "@cabanasathospampa",
  instagramLink: "https://instagram.com/cabanasdelcampocba",
  facebookLink: "https://www.facebook.com/cabanasathospampa",
  whatsappLink: "https://wa.me/5493513024564",
  googleMapsLink:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3383.0791245746664!2d-64.65091989999999!3d-32.0129703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95d2b7b8d681f39b%3A0xf9d55cbb51fb9408!2sCaba%C3%B1as%20del%20Campo!5e0!3m2!1ses!2sar!4v1737984225334!5m2!1ses!2sar",
};

// Abre Google Maps con la ruta hasta las cabañas
CONTACT_INFO.googleMapsDirections =
  "https://www.google.com/maps/dir/?api=1&destination=-32.0129703,-64.6509199";

// WhatsApp con un mensaje ya escrito para consultar disponibilidad
CONTACT_INFO.reservarLink = `${CONTACT_INFO.whatsappLink}?text=${encodeURIComponent(
  "¡Hola! Quisiera consultar disponibilidad en Cabañas del Campo."
)}`;

export default CONTACT_INFO;
